// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import TanStackBackend from "./tanstack-i18n-backend";
import translation from "../../locales/en/translation.json";

export const supportedLanguages = ["en", "nl", "fr", "de", "it", "es"];

export const defaultNS = "translation";
export const resources = {
  en: {
    translation,
  },
} as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

// Initialize i18next immediately
const initPromise = i18n
  .use(TanStackBackend) // Load translations using custom TanStack backend
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false, // Set to false in production
    interpolation: { escapeValue: false },
    react: {
      useSuspense: false, // Important for SSR to avoid suspense mismatches
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
    load: "languageOnly", // Only load language, not region
    // No `preload`: it would fetch a locale chunk for every supported language
    // on each page load. `setupI18n` loads the active locale on both the server
    // and the client, `en` is bundled statically via `resources` to satisfy
    // `fallbackLng`, and `I18nProvider` holds rendering until the namespace is
    // ready. Preloading the rest is pure waste.
    saveMissing: false, // Don't save missing translations to server
    missingKeyHandler: (lng, ns, key) => {
      console.warn(
        `Missing translation key: ${key} for language: ${lng} in namespace: ${ns}`
      );
    },
    // Ensure proper initialization
    initImmediate: true,
  });

export default i18n;
export { initPromise };
